export default "__VITE_ASSET__mq6EfAax__"